import gql from 'graphql-tag';

const MOVE_ORG = gql`
  mutation moveOrg(
  $id: ID!
  $connect: [OrgWhereUniqueInput!]
  $disconnect: [OrgWhereUniqueInput!]
  ) {
    moveOrg(
      where: { id: $id }
      data: { parentOrg: { connect: $connect, disconnect: $disconnect } }
    ) {
      id
      domain
      config {
        providersVisible
        isAdmin
        isPartner
        isTrafficker
        exportData
        isSelfService
        hasInsights
        priceVisible
        isProcessor
        canResetPasswords
        campaignSummary
        isPacing
        pastData
        segment
        articles
        amplify
        configurator
        billing
        sitesAppsTransactions
        isBeta
      }
      dataConfig {
        reTargeting
        appIds
        tradeDeskIdentifier
        storageBucket
        semrushEnable
        semrushConfig {
          projectId
          rootDomainUrl
          rootKeyword
          competitor1stRootDomainUrl
          competitor2ndRootDomainUrl
        }
        roasFormat
        defaultDisplayAttributionWindow
        defaultPaidSearchAttributionWindow
        defaultSEOAttributionWindow
        currency {
          currency
          conversionValue
        }
        tagProcessingConfig {
          processTag
        }
        paidSearchDataConfig {
          isEnabled
        }
      }
      paymentConfig {
        id
        providerId
        paymentProvider
      }
      brands(first: 2) {
        name
        logo {
          key
        }
      }
      name
      description
      locations(first: 5) {
        street
        city
        state
      }
      logo {
        id
        key
        url
      }
      signInLogo {
        id
        key
        url
      }
      roles(first: 50, where: { isMaster: true }) {
        id
        name
        roleItems(first: 15) {
          id
          feature
          actions
        }
        users(first: 30) {
          id
        }
        isMaster
      }
      level
      website
      platformDomain
      tagDomain
      parentOrder
      parentOrg {
        name
        id
      }
      zone
      chatWootId
      cpm
    }
  }
`;

export default MOVE_ORG;
